import { suppliersBrandValuePath } from "@faire/retailer-visitor-shared/paths/suppliers/suppliersBrandValuePath";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { getIsRobot } from "@faire/retailer-visitor-shared/serialized-data/getIsRobot";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { getSettingAllowedBrandTagDefinitions } from "@faire/retailer-visitor-shared/settings/getSettingAllowedBrandTagDefinitions";
import {
  StrictLocalizeFunction,
  useStrictLocalization,
} from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { IRoutingContext } from "@faire/web--source/ui/routing/RoutingContext";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { useMemo } from "react";

const BRAND_VALUES = (
  strictLocalize: StrictLocalizeFunction,
  routingContext: IRoutingContext
) => [
  {
    id: "WOMEN_OWNED",
    name: strictLocalize({
      defaultMessage: "Women owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/7253458b1cde21d4c723066f9fc33b3b5bf15650e8befdf5604129e034b2f2d5.jpeg",
      token: "b_9i29vt7r7q",
      name: "Flowerhead Tea",
      location: strictLocalize({
        defaultMessage: "Los Angeles, California",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Our love of community, strong women, the beautiful California landscape, and sipping tea from around the world were all the driving inspirations for our brand. We believe tea is best shared with a loved one, a couple laughs, and maybe a few tears.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop women owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "women-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "AAPI_OWNED",
    name: strictLocalize({
      defaultMessage: "AAPI owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/4ce1ff308ddf02d65d0838ae743c9559e3fa3080237457515843c9a014b09ce4.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/3ca9c2e4e464acc9870e0db0df34e4c181f552d5f3015eeb749f1a2016d020db.jpeg",
      name: "Omsom",
      token: "b_8moufefgyb",
      location: strictLocalize({
        defaultMessage: "Brooklyn, New York",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/4ce1ff308ddf02d65d0838ae743c9559e3fa3080237457515843c9a014b09ce4.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Started by Vietnamese-American sisters, Kim & Vanessa Pham, Omsom brings “proud + loud” Asian flavors to your home kitchen any day of the week. Our Saucy Noodles and Cooking Sauces are all crafted in partnership with Asian American chefs who share our mission to reclaim Asian American flavors too often diluted in the mainstream.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/4ce1ff308ddf02d65d0838ae743c9559e3fa3080237457515843c9a014b09ce4.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop AAPI owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/4ce1ff308ddf02d65d0838ae743c9559e3fa3080237457515843c9a014b09ce4.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "asian-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "BLACK_OWNED",
    name: strictLocalize({
      defaultMessage: "Black owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/dd059be7d87e4599c5e60ad2e7ccb494107fe055ea7e193844eb3042909ecfee.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/19461514dcb24eaa3212c59d391946ad319f459ca393174a7e74b1f6e33de0da.jpeg",
      name: "Homa Studios",
      token: "b_34v4ytdcyq",
      location: strictLocalize({
        defaultMessage: "Newark, New Jersey",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/dd059be7d87e4599c5e60ad2e7ccb494107fe055ea7e193844eb3042909ecfee.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Join Altarik Banks, the visionary behind Homa Studios, on a journey of artistic innovation. Homa Studios gives the everyday an upgrade with home and dining objects that prize craftsmanship, emerging technology and collaboration. All objects are designed and produced in-house in our Newark, NJ design studio and small batch manufacturer.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/dd059be7d87e4599c5e60ad2e7ccb494107fe055ea7e193844eb3042909ecfee.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop black owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/dd059be7d87e4599c5e60ad2e7ccb494107fe055ea7e193844eb3042909ecfee.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "black-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "LATINO_OWNED",
    name: strictLocalize({
      defaultMessage: "Latino owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/0cdffe8f9c6dcc5d49bbd50abc3a896fc83d9660a470d02e87e030a71b8dbfc5.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/98d42243548175b7b768fbc50f22f6e43719f5c716644ea094c7a26d46f7453d.jpeg",
      name: "Jen Zeano Designs",
      token: "b_azy7wyd985",
      location: strictLocalize({
        defaultMessage: "Brownsville, Texas",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/0cdffe8f9c6dcc5d49bbd50abc3a896fc83d9660a470d02e87e030a71b8dbfc5.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We’re a lifestyle brand that builds community and celebrates cultura every day! JZD started in 2016 because we felt like we needed a reminder of our power. We focus on creating products that make us feel represented and connected to our roots.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/0cdffe8f9c6dcc5d49bbd50abc3a896fc83d9660a470d02e87e030a71b8dbfc5.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop Latino owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/0cdffe8f9c6dcc5d49bbd50abc3a896fc83d9660a470d02e87e030a71b8dbfc5.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "latino-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "LGBTQ_OWNED",
    name: strictLocalize({
      defaultMessage: "LGBTQI+ owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/b09ea79a42ec4f9480327b8ca71374eb5f620a8a69ca519846518bd69ab2b0e1.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/70f1f9fb4d2cc1301e62e2a841a4d9593ca6665a5a2854a2d1b8ce0b67aa3aab.jpeg",
      name: "MINNA",
      token: "b_c693d5d2",
      location: strictLocalize({
        defaultMessage: "Hudson, New York",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/b09ea79a42ec4f9480327b8ca71374eb5f620a8a69ca519846518bd69ab2b0e1.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We are a women and queer led business, which informs our approach to just about everything we do. We believe in creating beautiful, ethically made products and using business to do good. Our handcrafted heirloom textiles weave together traditional techniques with a contemporary aesthetic for thoughtful, timeless interiors rooted in responsible design.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/b09ea79a42ec4f9480327b8ca71374eb5f620a8a69ca519846518bd69ab2b0e1.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop LGBTQI+ owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/b09ea79a42ec4f9480327b8ca71374eb5f620a8a69ca519846518bd69ab2b0e1.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "lgbtq_owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ECO_FRIENDLY",
    name: strictLocalize({
      defaultMessage: "Eco-friendly",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/fcb3ab46fe7b33a096d79e6a0bbcbdb8d4109b7c3f3bfcc5438dd22cc42c5d67.jpeg",
      name: "Bathing Culture",
      token: "b_abkrtd2v7r",
      location: strictLocalize({
        defaultMessage: "San Francisco, California",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We package each product with care for its carbon impact, use, reuse, and end of life. The cornerstone of our approach is our refill program for Mind and Body Wash, which lets you refill your soap at over 200 stores nationwide.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop eco-friendly",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "eco-friendly",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ORGANIC",
    name: strictLocalize({
      defaultMessage: "Organic",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/c152bd09126524a08fa2bd30e727b79d14ed4eb64d188fa35a8645265bc45181.jpeg",
      name: "Inners",
      token: "b_vp5gtymf3t",
      location: strictLocalize({
        defaultMessage: "Paris, France",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We are convinced that health cannot be resolved by swallowing a simple pill, but by permanently changing our eating habits. This is why we have formulated adaptogen coffees and powdered supplements, natural and organic, that are easy to use in our drinks or in our food. Our mission? Decomplexify health by making it easy, tasty and accessible to as many people as possible.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop organic",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "organic",
          routingContext,
        }),
      },
    },
  },
  {
    id: "HANDMADE",
    name: strictLocalize({
      defaultMessage: "Handmade",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/a4521b578a0c3135dc8285f0e1ac9f38143d377013e276472a1cf4a3249533fe.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/a1e68b120dbd88e3ecb5e65d5a4d309bab3608eafbbfb52c47c2c58b5c7f2160.png",
      name: "Hampui Hats",
      token: "b_c6c16wmx83",
      location: strictLocalize({
        defaultMessage: "Berkeley, California",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/8b9a915095cb74bf58e2e794b067e79df89628119a84c0200467bbcdd3616d59.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“From the ethical sourcing of their materials to their mindful construction, we make hats that you can wear with pride and purpose.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/8b9a915095cb74bf58e2e794b067e79df89628119a84c0200467bbcdd3616d59.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop handmade",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/a4521b578a0c3135dc8285f0e1ac9f38143d377013e276472a1cf4a3249533fe.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "hand-made",
          routingContext,
        }),
      },
    },
  },
  {
    id: "NOT_SOLD_ON_AMAZON",
    name: strictLocalize({
      defaultMessage: "Not on Amazon",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/56ef582a1cca0c6d2ca18e5fdc76683f074c32d597aa60db2f1330beba84149a.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/e6bccb73f645caf72486f8aec6725e6f7b9da30a2021cb29abeb02534bbea8a1.png",
      name: "Loam Candles",
      token: "b_jx5r7yrney",
      location: strictLocalize({
        defaultMessage: "Los Angeles, California",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/dcb9316bcd5790ce70bdfd6af378927db25e6a096bd16972a0f0d0e85d10c7c2.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We craft scents that celebrate and honor the magic of a life lived in the garden and experienced outdoors. All Loam Candles are made with a blend of soy and coconut wax, cotton wicks and clean fragrances.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/dcb9316bcd5790ce70bdfd6af378927db25e6a096bd16972a0f0d0e85d10c7c2.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop not on Amazon",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/56ef582a1cca0c6d2ca18e5fdc76683f074c32d597aa60db2f1330beba84149a.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "not-sold-on-amazon",
          routingContext,
        }),
      },
    },
  },
  {
    id: "GIVES_BACK",
    name: strictLocalize({
      defaultMessage: "Gives back",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/85b28965592d4f9e79d258f5cf547953f374028661ff237f058d3892cf5cb8f4.jpeg",
      name: "Capra Designs",
      token: "b_2r0cx7b15w",
      location: strictLocalize({
        defaultMessage: "Balnarring Beach, Australia",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“First inspired by nature, Capra Designs holds a commitment to operate thoughtfully through the practices, processes and materials that bring our designs to life. We are ever pursuing cleaner and lighter alternatives that are kinder on the planet. Capra Designs donates a portion of every sale via I=Change.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop gives back",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "gives-back",
          routingContext,
        }),
      },
    },
  },
  {
    id: "WOMEN_OWNED_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Women owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/7253458b1cde21d4c723066f9fc33b3b5bf15650e8befdf5604129e034b2f2d5.jpeg",
      name: "pretti.cool",
      token: "b_a93c4hrj",
      location: strictLocalize({
        defaultMessage: "Houston, Texas",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Pretti.Cool was founded by a bunch of 90's kids who wanted an excuse to collaborate on making products that are both practical and fun.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop women owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "women-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "AAPI_OWNED_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "AAPI owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/81cecadb6c62b4a5c8247c521b732d67edaab16f395669317c789f8a376aeb25.jpeg",
      name: "Fly By Jing",
      token: "b_6v0qhuk6mq",
      location: strictLocalize({
        defaultMessage: "Los Angeles, California",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Founded in 2018 by Jing Gao, a chef, entrepreneur and renowned expert on Chinese cuisine, we’re on a mission to evolve culture through taste and expand palates and minds.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop AAPI owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/4ce1ff308ddf02d65d0838ae743c9559e3fa3080237457515843c9a014b09ce4.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "asian-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "BLACK_OWNED_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Black owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/19461514dcb24eaa3212c59d391946ad319f459ca393174a7e74b1f6e33de0da.jpeg",
      name: "Hot N Saucy",
      token: "b_6tr8251azl",
      location: strictLocalize({
        defaultMessage: "Powder Springs, Georgia",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Hot N Saucy is a proudly black-owned business making your classic hot sauce, reimagined. With vgetable based sauces curated in small batches by Chef Sam Davis-Allonce, our bright, bold and colorful sauces give you the heat you want and need at no additive cost. Yep, it’s all sauce and all natural.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop black owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/dd059be7d87e4599c5e60ad2e7ccb494107fe055ea7e193844eb3042909ecfee.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "black-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "LATINO_OWNED_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Latino owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/98d42243548175b7b768fbc50f22f6e43719f5c716644ea094c7a26d46f7453d.jpeg",
      name: "Masienda",
      token: "b_40klkr9v3l",
      location: strictLocalize({
        defaultMessage: "Santa Monica, California, United States",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Masienda is collectively owned by our team, based across the US and Mexico. Representing distinct perspectives from throughout the masa foodway, we are proud to serve professional chefs and home cooks with the ingredients and tools needed to make the best masa-based dishes in their own kitchens. Bienvenidos.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop Latino owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/0cdffe8f9c6dcc5d49bbd50abc3a896fc83d9660a470d02e87e030a71b8dbfc5.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "latino-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "LGBTQ_OWNED_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "LGBTQI+ owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/70f1f9fb4d2cc1301e62e2a841a4d9593ca6665a5a2854a2d1b8ce0b67aa3aab.jpeg",
      name: "Han's Kombucha by HK Brewing Collective",
      token: "b_kg3btcjn6r",
      location: strictLocalize({
        defaultMessage: "Salt Lake City, Utah",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "\"Born from the fierce spirit of women leaders and proudly queer-owned, we're here to shatter your preconceived notions about kombucha. Forget the bland and predictable—we're on a mission to redefine the probiotic beverage game. Join us in flipping the script on probiotic experiences!\"",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop LGBTQI+ owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/b09ea79a42ec4f9480327b8ca71374eb5f620a8a69ca519846518bd69ab2b0e1.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "lgbtq_owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ECO_FRIENDLY_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Eco-friendly",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/fcb3ab46fe7b33a096d79e6a0bbcbdb8d4109b7c3f3bfcc5438dd22cc42c5d67.jpeg",
      name: "Juniper Ridge",
      token: "b_7ikf86lq",
      location: strictLocalize({
        defaultMessage: "Oakland, California",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We use sustainably harvested plants and steam distillation to craft fragrance for home & body in Oakland, CA. By focusing on plants native to the West Coast, we bring the beauty of its natural splendor into your home. Juniper Ridge is paraben and sulfate-free, dye-free, petroleum product free, and cruelty-free–good for the whole person.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop eco-friendly",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "eco-friendly",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ORGANIC_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Organic",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/c152bd09126524a08fa2bd30e727b79d14ed4eb64d188fa35a8645265bc45181.jpeg",
      name: "3rd Ritual",
      token: "b_46xe649o7x",
      location: strictLocalize({
        defaultMessage: "Brooklyn, New York",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“3rd Ritual is a mindful collective founded by aromatherapist and meditation teacher Jenn Tardif. Everything we create—from botanical blends to limited edition home objects—is inspired by the belief that simple rituals lead to sacred experiences.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop organic",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "organic",
          routingContext,
        }),
      },
    },
  },
  {
    id: "HANDMADE_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Handmade",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/254d7229f41f43695b521b8df2f362cf780b6327109cf38efd14bf3c3253c761.jpeg",
      name: "VERLOOP | knits",
      token: "b_bganl3cn3b",
      location: strictLocalize({
        defaultMessage: "Denton, Maryland",
        description: {
          text: "Brand value banner brand name",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“VERLOOP is on a mission to reduce textile waste with playful, resourceful design. Made in a family-owned factory in the Philippines, VERLOOP knits repurpose deadstock material and bring feel-good color to everyday life.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop handmade",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/a4521b578a0c3135dc8285f0e1ac9f38143d377013e276472a1cf4a3249533fe.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "hand-made",
          routingContext,
        }),
      },
    },
  },
  {
    id: "NOT_SOLD_ON_AMAZON_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Not on Amazon",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/97db8726b20e7cf5dbd5853adb2c5f7503b36279ff536d1496eb11db81d6e71e.jpeg",
      name: "Potluck",
      token: "b_mkwgw6t63p",
      location: strictLocalize({
        defaultMessage: "Boston, Massachusetts",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We're reimagining the classics and partnering with a network of skilled makers to do it. Potluck is bold flavors and no fillers—grounded in tradition but not bound by its rules. We’re meant for big nights, dinners-for-one, potlucks and pick-me-ups.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop not on Amazon",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/56ef582a1cca0c6d2ca18e5fdc76683f074c32d597aa60db2f1330beba84149a.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "not-sold-on-amazon",
          routingContext,
        }),
      },
    },
  },
  {
    id: "GIVES_BACK_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Gives back",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/29de9648f2db72ff86ebcbbb6afa22097fb83322082877de6581cb52f695d8e3.jpeg",
      name: "Original Duckhead US",
      token: "b_i0685gpmim",
      location: strictLocalize({
        defaultMessage: "London, United Kingdom",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We're an umbrella company implementing innovative design technology to save post-consumer plastic waste from landfills and seas. We have recycled over 3 million post-consumer plastic bottles, and our mission is to recycle over 10 million plastic bottles by 2030. Our ultimate goal is to give back more than we take.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop gives back",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "gives-back",
          routingContext,
        }),
      },
    },
  },
];

const UK_BRAND_VALUES = (
  strictLocalize: StrictLocalizeFunction,
  routingContext: IRoutingContext
) => [
  {
    id: "MADE_IN_UK",
    name: strictLocalize({
      defaultMessage: "Made in UK",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/f96746a0e149a336523e8c21ee4f39f704bde45f385df62110227c014a444d39.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/99007aaa5705ec5ada1822f6193e2c48fe5730fa1215341f166c20062fc04091.jpeg",
      name: "Cotton Clara",
      location: strictLocalize({
        defaultMessage: "Loughborough, United Kingdom",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/f96746a0e149a336523e8c21ee4f39f704bde45f385df62110227c014a444d39.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Cotton Clara is designed for a new generation of makers seeking relaxation through craft. We believe crafting is therapeutic, which is why our easy-to-complete kits are perfect for all ages. With giftable packaging and beautiful designs, each kit includes clear instructions for an enjoyable experience. Proudly made in our Leicestershire studio, we focus on quality and creativity that keeps crafters inspired.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/f96746a0e149a336523e8c21ee4f39f704bde45f385df62110227c014a444d39.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop made in UK",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/f96746a0e149a336523e8c21ee4f39f704bde45f385df62110227c014a444d39.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "made-in-uk",
          routingContext,
        }),
      },
    },
  },
  {
    id: "WOMEN_OWNED",
    name: strictLocalize({
      defaultMessage: "Women owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/23df6d0c59080b25d49c875a430e7b5dcc65774a1b47715581ce88f03e14a435.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/ab5c717650edabc693b6ef051893c7541288e94c73888403d6372d4235dbd99f.jpeg",
      name: "Another Studio",
      location: strictLocalize({
        defaultMessage: "London, United Kingdom",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/23df6d0c59080b25d49c875a430e7b5dcc65774a1b47715581ce88f03e14a435.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Inspired by ephemera, natural history, architecture, and our love for pets, we create playful and unique products, including stationery, DIY craft kits, plant care guides, and houseplant decorations. In 2017, we launched Plant Animals, our best-selling houseplant decoration, which continues to bring charm and creativity to homes.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/23df6d0c59080b25d49c875a430e7b5dcc65774a1b47715581ce88f03e14a435.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop women owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/23df6d0c59080b25d49c875a430e7b5dcc65774a1b47715581ce88f03e14a435.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "women-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "BLACK_OWNED",
    name: strictLocalize({
      defaultMessage: "Black owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/50e16ad7d77517d2adc4df34b3041c02daffed7f5298908d69b2f6885284c8fd.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/eed655029e6165287afa2306ed40988abe37e2ed1a31bba06b2d770d1b682f8f.jpeg",
      name: "Afropop",
      location: strictLocalize({
        defaultMessage: "Northampton, United Kingdom",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/50e16ad7d77517d2adc4df34b3041c02daffed7f5298908d69b2f6885284c8fd.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Afropop Socks offers a fun and accessible way for people of all backgrounds to experience African pop culture! Our socks serve as wearable art, with each pair of socks featuring distinctive patterns and motifs that are not only fashionable but also represent the wide ranging cultural tapestry of Africa.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/50e16ad7d77517d2adc4df34b3041c02daffed7f5298908d69b2f6885284c8fd.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop black owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/50e16ad7d77517d2adc4df34b3041c02daffed7f5298908d69b2f6885284c8fd.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "black-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "LGBTQ_OWNED",
    name: strictLocalize({
      defaultMessage: "LGBTQI+ owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/22a0de8ddb095b36642ac2e4e3e3552509c1b86aaedffed597d2ee9a01c66003.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/6e1accb6b7a6ed13c3e2bdac61ac4dd71bcad9f2c4b0a348f5da70d875a2bc92.jpeg",
      name: "Gohobi",
      location: strictLocalize({
        defaultMessage: "United Kingdom",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/22a0de8ddb095b36642ac2e4e3e3552509c1b86aaedffed597d2ee9a01c66003.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Gohobi is a queer-led London-based handcrafted homeware and lifestyle brand, inspired by East Asian art, culture and history. We collaborate directly with artists, producers and farmers to celebrate diversity, local community and promoting wellness.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/22a0de8ddb095b36642ac2e4e3e3552509c1b86aaedffed597d2ee9a01c66003.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop LGBTQI+ owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/22a0de8ddb095b36642ac2e4e3e3552509c1b86aaedffed597d2ee9a01c66003.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "lgbtq_owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ECO_FRIENDLY",
    name: strictLocalize({
      defaultMessage: "Eco-friendly",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/ec3198ad7ab507a255265ac2b75db8d94c8f7608e96b483e5eb89f14393a4f6d.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/fc80d2705ba2b3b1e56bf13130ab4ed8232cb90f5a58a31575dc4952a1a4a2a3.jpeg",
      name: "Who Gives A Crap",
      location: strictLocalize({
        defaultMessage: "United Kingdom",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/ec3198ad7ab507a255265ac2b75db8d94c8f7608e96b483e5eb89f14393a4f6d.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We believe wiping should do more than just clean your behind — it should help the planet, too! That’s why we make eco-friendly toilet paper and donate 50% of our profits to ensure everyone in the world has access to clean water and a toilet.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/ec3198ad7ab507a255265ac2b75db8d94c8f7608e96b483e5eb89f14393a4f6d.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop eco-friendly",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/ec3198ad7ab507a255265ac2b75db8d94c8f7608e96b483e5eb89f14393a4f6d.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "eco-friendly",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ORGANIC",
    name: strictLocalize({
      defaultMessage: "Organic",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/bd6261057dad478625b078fb9b8c20df852ba19192a0d9ac643917fe989cc2c8.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/5bfac682c3370742d5dd58793d7a81c1bb51fa409e48807c346a8d77f07c9ea0.jpeg",
      name: "Silverstick",
      location: strictLocalize({
        defaultMessage: "Lewes, United Kingdom",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/bd6261057dad478625b078fb9b8c20df852ba19192a0d9ac643917fe989cc2c8.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Our clothes are designed to feel comfortable and look great wherever you are. They’re rugged enough to thrive in the wild (and believe us, we put every garment through its paces). And they’re produced in tune with nature to help support and protect our beloved outdoor playgrounds.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/bd6261057dad478625b078fb9b8c20df852ba19192a0d9ac643917fe989cc2c8.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop organic",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/bd6261057dad478625b078fb9b8c20df852ba19192a0d9ac643917fe989cc2c8.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "organic",
          routingContext,
        }),
      },
    },
  },
  {
    id: "HANDMADE",
    name: strictLocalize({
      defaultMessage: "Handmade",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/682a45b94fc0742ea5c97ae7c6b2a2f490a9988b7cc375f25665701cec96d528.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/d937058355bc9aae482021329d663416b6474a0e4025324f78fbd5ef605cd54d.jpeg",
      name: "ONSURI",
      location: strictLocalize({
        defaultMessage: "London, United Kingdom",
        description: {
          text: "Brand value banner brand name",
          img: "https://cdn.faire.com/fastly/682a45b94fc0742ea5c97ae7c6b2a2f490a9988b7cc375f25665701cec96d528.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“ONSURI, a multi-award-winning olive oil brand, is transforming the industry with its ultra-premium oils from Jordan. Known for its sustainable, recyclable tins and bold designs, ONSURI combines tradition with innovation. Their oils, crafted to elevate any dish, redefine luxury through authenticity and quality, not price.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/682a45b94fc0742ea5c97ae7c6b2a2f490a9988b7cc375f25665701cec96d528.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop handmade",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/682a45b94fc0742ea5c97ae7c6b2a2f490a9988b7cc375f25665701cec96d528.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "hand-made",
          routingContext,
        }),
      },
    },
  },
  {
    id: "NOT_SOLD_ON_AMAZON",
    name: strictLocalize({
      defaultMessage: "Not on Amazon",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/1e1cf66ed9e4e07d3d137a5440c2faecdaad035b13b4dc9635638c4da788b4d8.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/f1fa401c322be0a4ede788a5cbcb504f89f1a1a5ee5311eb3513ec1f35746365.jpeg",
      name: "Atlantic Blankets",
      location: strictLocalize({
        defaultMessage: "Perranporth Cornwall, United Kingdom",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/1e1cf66ed9e4e07d3d137a5440c2faecdaad035b13b4dc9635638c4da788b4d8.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Our blankets, designed in Cornwall and sustainably made in the British Isles, carry the essence of the Atlantic in their soft fibers. Whether draped over a sofa or thrown onto the sand, they invite you to slow down, breathe, and live simply—no user manual required.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/1e1cf66ed9e4e07d3d137a5440c2faecdaad035b13b4dc9635638c4da788b4d8.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop not on Amazon",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/1e1cf66ed9e4e07d3d137a5440c2faecdaad035b13b4dc9635638c4da788b4d8.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "not-sold-on-amazon",
          routingContext,
        }),
      },
    },
  },
  {
    id: "GIVES_BACK",
    name: strictLocalize({
      defaultMessage: "Gives back",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/0edeeb9bffea09022cbb9d3aceef7931e00708ed81a6e38a682352c90b867f14.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/65d39f2dd83e90ca1d88062aa0566ba0c6f5e2247dc2f67ec8ec34016f8d4f67.jpeg",
      name: "Sophie Home Ltd",
      location: strictLocalize({
        defaultMessage: "United Kingdom",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/0edeeb9bffea09022cbb9d3aceef7931e00708ed81a6e38a682352c90b867f14.png", // Update
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Sophie Home is a contemporary home textiles label based in London, UK. Our work is bold, contemporary and colourful. Everything is knitted in 100% cotton making for the softest pillows, throws and nursery accessories. We donate 5% of our profits to Choose Love, a charity that supports refugees in their greatest time of need.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/0edeeb9bffea09022cbb9d3aceef7931e00708ed81a6e38a682352c90b867f14.png", // Update
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop gives back",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/0edeeb9bffea09022cbb9d3aceef7931e00708ed81a6e38a682352c90b867f14.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "gives-back",
          routingContext,
        }),
      },
    },
  },
];

const FR_BRAND_VALUES = (
  strictLocalize: StrictLocalizeFunction,
  routingContext: IRoutingContext
) => [
  {
    id: "MADE_IN_FRANCE",
    name: strictLocalize({
      defaultMessage: "Made in France",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png", // Update
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/bf8b30eb89a944efef9dec506d8034522e6f8bd4acea268d867fb3c7b5080977.jpeg",
      name: "JOMO - THÉ GLACÉ BIO",
      location: strictLocalize({
        defaultMessage: "France",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/c2ee2bd734b78bc571c7dda26236fd588d496191c708a1117342e09352ea2922.png", // Update
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“At JOMO, we create healthy, delicious, and responsible drinks. Our vision blends harmony and aesthetics, with a focus on organic ingredients and meaningful human connections. We imagine balanced drinks that meet our wellness needs while reflecting our values of passion and uniqueness.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/c83c897531352e3be76672ec6645be11ae2223cc01dff96a7788806de46d28d1.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop made in France",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png", // Update
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "made-in-france",
          routingContext,
        }),
      },
    },
  },
  {
    id: "WOMEN_OWNED",
    name: strictLocalize({
      defaultMessage: "Women owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/47b735e5bd8ed4235b25469a81f2cb799acc4fb0dae98371e0a14dbe4f90346b.jpeg",
      name: "L’infuseur",
      location: strictLocalize({
        defaultMessage: "France",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/c2ee2bd734b78bc571c7dda26236fd588d496191c708a1117342e09352ea2922.png", // Update
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Women have always been my inspiration, and it’s thanks to my grandmother that I developed my passion for plants. I founded L’infuseur in 2012 as a passion project, and by 2018, I built a team to create refined blends of teas and herbs, inviting a healthier lifestyle. Made in France, our tea bags have been 100% compostable since the very beginning of our journey.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/c83c897531352e3be76672ec6645be11ae2223cc01dff96a7788806de46d28d1.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop women owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png", // Update
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "women-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ECO_FRIENDLY",
    name: strictLocalize({
      defaultMessage: "Eco-friendly",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/49113b9169cb1ac0170b05d02201591e5cf188f9fb34d3104e4152661bf7c10b.jpeg",
      name: "VERSATILE PARIS",
      location: strictLocalize({
        defaultMessage: "Paris, France",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/c2ee2bd734b78bc571c7dda26236fd588d496191c708a1117342e09352ea2922.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Versatile was born from the desire to make the institutional bold. Versatile is an alternative brand with great-smelling, genderless products that have names that make you smile!”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/a185fcca936a341d047cb71a321918c634b454a96ae6c178c706fefdc48ab086.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop eco-friendly",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png", // Update
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "eco-friendly",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ORGANIC",
    name: strictLocalize({
      defaultMessage: "Organic",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/d453d5ee865e993eb1b03be2e7570d03bd25a0d005db917a69533e0ddc67ffad.jpeg", // Update
      name: "Hindbag",
      location: strictLocalize({
        defaultMessage: "Paris, France",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/c2ee2bd734b78bc571c7dda26236fd588d496191c708a1117342e09352ea2922.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“At Hindbag, we offer colorful bags and accessories that combine style and commitment. Our partnership with the NGO SSMI supports the empowerment of women in India through training and employment, with fair and adapted working conditions. We produce ethically while offering affordable bags and accessories, making eco-responsibility more accessible.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/cc191bf60ef918f109818e68298f1972af61b3d1e2d09aa9148dc24c48303c88.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop organic",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "organic",
          routingContext,
        }),
      },
    },
  },
  {
    id: "HANDMADE",
    name: strictLocalize({
      defaultMessage: "Handmade",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/a4521b578a0c3135dc8285f0e1ac9f38143d377013e276472a1cf4a3249533fe.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/e61e3cfeccd8d801feaeaffcec790a1685b784c6d340847fabbc7f8decc8a1ae.jpeg",
      name: "Fer à Cheval",
      location: strictLocalize({
        defaultMessage: "France",
        description: {
          text: "Brand value banner brand name",
          img: "https://cdn.faire.com/fastly/c2ee2bd734b78bc571c7dda26236fd588d496191c708a1117342e09352ea2922.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We respect and continue an artisanal expertise passed down from generation to generation of master soap makers. The recipe for authentic Marseille soap, cooked in a cauldron, is carefully preserved and remains unchanged to this day, as it’s remarkably effective and gentle for the whole family. Our Fer à Cheval Soap Factory is intertwined with Marseille’s heritage, as our story is also the story of the region and its people.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/b97e7763d128fe0ee4ad4d866cd74fa3638e7d28797576e065dae78ce8174a72.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop handmade",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/a4521b578a0c3135dc8285f0e1ac9f38143d377013e276472a1cf4a3249533fe.png", // Update
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "hand-made",
          routingContext,
        }),
      },
    },
  },
  {
    id: "NOT_SOLD_ON_AMAZON",
    name: strictLocalize({
      defaultMessage: "Not on Amazon",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/56ef582a1cca0c6d2ca18e5fdc76683f074c32d597aa60db2f1330beba84149a.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/d6c75104593fcc1fb4c436b7171cc14eff2028ed758ef5322a828f9f819cb923.jpeg",
      name: "Rose in April",
      location: strictLocalize({
        defaultMessage: "Paris, France",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/c2ee2bd734b78bc571c7dda26236fd588d496191c708a1117342e09352ea2922.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Rose in April is a beautiful family adventure founded by two sisters, Élodie and Eugénie, to create fun and quality products, inspired by their children. Today, a small team of passionate women continues to joyfully develop the brand, making everyday life more fun for moms and their kids.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/9ef487b9e3fa039cbe00c3d92789b6a756479145ea4010700d1ec73214fd640b.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop not on Amazon",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/56ef582a1cca0c6d2ca18e5fdc76683f074c32d597aa60db2f1330beba84149a.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "not-sold-on-amazon",
          routingContext,
        }),
      },
    },
  },
  {
    id: "GIVES_BACK",
    name: strictLocalize({
      defaultMessage: "Gives back",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/1f05b19413202108e6b7c9f09434edaf7e2551a94e26f987d2ef205dbe6a6038.jpeg",
      name: "La Petite Épicerie",
      location: strictLocalize({
        defaultMessage: "Montreuil, France",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/9ef487b9e3fa039cbe00c3d92789b6a756479145ea4010700d1ec73214fd640b.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“If there’s one thing you should know about us, it’s that we are very curious and inventive. Always on the lookout for the latest creative and handmade trends, we love surprising you with original and innovative products that spark creativity.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/9ef487b9e3fa039cbe00c3d92789b6a756479145ea4010700d1ec73214fd640b.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop gives back",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "gives-back",
          routingContext,
        }),
      },
    },
  },
];

export interface BrandInfo {
  image: string;
  name: string;
  location: string;
  description: string;
  cta: { name: string; link: string };
  token?: string;
}

export const getBrandValuesLocale = (
  localeCountry?: string,
  countryCode?: keyof typeof ISO3166Alpha3,
  isRobot?: boolean
) => {
  if (
    ((isRobot && localeCountry === "FRA") ||
      (!isRobot && countryCode === "FRA"))
  ) {
    return "FRA";
  }

  if (
    ((isRobot && localeCountry === "GBR") ||
      (!isRobot && countryCode === "GBR"))
  ) {
    return "GBR";
  }
  return null;
};

export const useGetBrandValues = (): {
  id: string;
  name: string;
  brand: BrandInfo;
}[] => {
  const isRobot = getIsRobot();
  const localeCountry = getLocaleKey()?.country;

  const { strictLocalize } = useStrictLocalization();
  const routingContext = useRetailerRoutingContext();
  const countryCode = getSessionCountry();
  const brandValues = useMemo(() => {
    const allowedBrandValues = new Set(getSettingAllowedBrandTagDefinitions());
    const values = BRAND_VALUES(strictLocalize, routingContext);
    return (
      values
        .map((brandValue) =>
          allowedBrandValues.has(brandValue.id) ? brandValue : undefined
        )
        .filter(isNotUndefined) ?? []
    );
  }, [routingContext, strictLocalize]);

  const brandValuesLocale = getBrandValuesLocale(
    localeCountry,
    countryCode,
    isRobot
  );

  if (brandValuesLocale === "GBR") {
    return UK_BRAND_VALUES(strictLocalize, routingContext);
  }
  if (brandValuesLocale === "FRA") {
    return FR_BRAND_VALUES(strictLocalize, routingContext);
  }
  return brandValues;
};
